import type { RunState } from '@crackpoint/shared/types';
import { useTheme } from './ThemeProvider';

interface StatusBarProps {
  run: RunState;
}

export function StatusBar({ run }: StatusBarProps) {
  const { theme } = useTheme();

  const isDanger = run.lives_remaining <= 2;
  const hasStreak = run.current_streak > 0;

  const heartColour = isDanger ? theme.colours.accent.error : theme.colours.accent.success;

  return (
    <div
      className="status-bar"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing.md,
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        backgroundColor: theme.colours.background.elevated,
        borderBottom: `2px solid ${theme.colours.background.tertiary}`,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.fontSize.md,
        fontWeight: theme.typography.fontWeight.medium,
      }}
    >
      <div
        className="status-bar__lives"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing.xs,
          color: heartColour,
        }}
      >
        {Array.from({ length: run.lives_remaining }, (_, i) => (
          <span key={i} style={{ fontSize: theme.typography.fontSize.lg }}>
            ❤️
          </span>
        ))}
      </div>

      <div
        className="status-bar__stats"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing.lg,
          color: theme.colours.text.primary,
        }}
      >
        <div className="status-bar__stars" style={{ display: 'flex', alignItems: 'center', gap: theme.spacing.xs }}>
          <span style={{ fontSize: theme.typography.fontSize.lg }}>⭐</span>
          <span>{run.total_stars}</span>
        </div>

        {hasStreak && (
          <div className="status-bar__streak" style={{ display: 'flex', alignItems: 'center', gap: theme.spacing.xs }}>
            <span style={{ fontSize: theme.typography.fontSize.lg }}>🔥</span>
            <span>{run.current_streak}</span>
          </div>
        )}

        <div
          className="status-bar__inventory"
          style={{ display: 'flex', alignItems: 'center', gap: theme.spacing.xs }}
        >
          <span style={{ fontSize: theme.typography.fontSize.lg }}>🎒</span>
          <span>{run.inventory.length}</span>
        </div>
      </div>
    </div>
  );
}
